

























































import {
  Cadastros,
  DashboardService,
  TotalAssinantes,
} from "@/services/dashboard.service";
import { dateFullNameMonth, dateYear } from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import DeltaAssinantesCard from "./components/mensal/DeltaAssinantesCard.vue";
import GraficoColunasCadastrosMensais from "./components/mensal/GraficoColunasCadastrosMensais.vue";
import GraficoDonutCadastrosMensais from "./components/mensal/GraficoDonutCadastrosMensais.vue";
import ClientesQueNaoRenovaramCard from "./components/mensal/ClientesQueNaoRenovaramCard.vue";
import TotalUsuariosCard from "./components/mensal/TotalUsuariosCard.vue";

@Component({
  components: {
    GraficoDonutCadastrosMensais,
    GraficoColunasCadastrosMensais,
    TotalUsuariosCard,
    DeltaAssinantesCard,
    ClientesQueNaoRenovaramCard,
  },
  filters: { dateFullNameMonth, dateYear },
})
export default class DashboardTvMensal extends Mixins(GlobalMixin) {
  loadingCadastros = false;
  show = false;
  cadastros: Cadastros[] | null = null;

  loadingAssinantes = false;
  totalAssinantes: TotalAssinantes[] | null = null;

  @Prop() date!: string | null;
  dateSync: string | null = null;

  mounted() {
    this.fetch();
  }

  @Watch("date")
  fetch() {
    this.show = true;
    if (!this.date) {
      this.dateSync = dayjs().format("YYYY-MM");
    } else {
      this.dateSync = dayjs(this.date).format("YYYY-MM");
    }
    dayjs.locale("pt-br");

    this.carregarCadastros();
    this.carregarAssinantes();
  }

  async carregarAssinantes() {
    this.loadingAssinantes = true;
    if (this.dateSync) {
      this.totalAssinantes = await DashboardService.Planos(
        this.dateSync
      ).finally(() => (this.loadingAssinantes = false));
    }
  }

  async carregarCadastros() {
    this.loadingCadastros = true;
    if (this.dateSync) {
      this.cadastros = await DashboardService.Cadastros(
        this.dateSync
      ).finally(() => (this.loadingCadastros = false)
      );
    }
  }
}
